const flightData = {
  data: [
    {
      countryCode: "JP",
      stationSchedules: [
        {
          iataCode: "NRT",
          schedules: [
            {
              origin: "TPE",
              destination: "NRT",
              carrierCode: "IT",
              flightNumber: "200",
              departureTime: "06:35:00",
              arrivalTime: "11:00:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 205,
            },
            {
              origin: "TPE",
              destination: "NRT",
              carrierCode: "IT",
              flightNumber: "202",
              departureTime: "14:25:00",
              arrivalTime: "18:35:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: true,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 190,
            },
            {
              origin: "TPE",
              destination: "NRT",
              carrierCode: "IT",
              flightNumber: "700",
              departureTime: "15:30:00",
              arrivalTime: "19:55:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 205,
            },
            {
              origin: "NRT",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "201",
              departureTime: "11:50:00",
              arrivalTime: "14:40:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 230,
            },
            {
              origin: "NRT",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "201",
              departureTime: "13:30:00",
              arrivalTime: "16:25:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: true,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 235,
            },
            {
              origin: "NRT",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "203",
              departureTime: "19:30:00",
              arrivalTime: "22:35:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: true,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 245,
            },
            {
              origin: "NRT",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "701",
              departureTime: "20:45:00",
              arrivalTime: "23:25:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 220,
            },
            {
              origin: "KHH",
              destination: "NRT",
              carrierCode: "IT",
              flightNumber: "280",
              departureTime: "08:05:00",
              arrivalTime: "12:40:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 215,
            },
            {
              origin: "NRT",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "281",
              departureTime: "11:50:00",
              arrivalTime: "15:00:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: true,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 250,
            },
            {
              origin: "NRT",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "281",
              departureTime: "13:30:00",
              arrivalTime: "16:40:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 250,
            },
          ],
        },
        {
          iataCode: "HND",
          schedules: [
            {
              origin: "TPE",
              destination: "HND",
              carrierCode: "IT",
              flightNumber: "216",
              departureTime: "00:10:00",
              arrivalTime: "04:25:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 195,
            },
            {
              origin: "HND",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "217",
              departureTime: "05:25:00",
              arrivalTime: "08:00:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 215,
            },
          ],
        },
        {
          iataCode: "HSG",
          schedules: [
            {
              origin: "TPE",
              destination: "HSG",
              carrierCode: "IT",
              flightNumber: "246",
              departureTime: "06:55:00",
              arrivalTime: "10:35:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 160,
            },
            {
              origin: "TPE",
              destination: "HSG",
              carrierCode: "IT",
              flightNumber: "246",
              departureTime: "07:10:00",
              arrivalTime: "10:35:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 145,
            },
            {
              origin: "HSG",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "247",
              departureTime: "11:35:00",
              arrivalTime: "13:05:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 150,
            },
          ],
        },
        {
          iataCode: "KMI",
          schedules: [
            {
              origin: "TPE",
              destination: "KMI",
              carrierCode: "IT",
              flightNumber: "742",
              departureTime: "06:20:00",
              arrivalTime: "09:20:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 120,
            },
            {
              origin: "KMI",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "743",
              departureTime: "10:30:00",
              arrivalTime: "11:55:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 145,
            },
          ],
        },
        {
          iataCode: "KIX",
          schedules: [
            {
              origin: "TPE",
              destination: "KIX",
              carrierCode: "IT",
              flightNumber: "210",
              departureTime: "06:40:00",
              arrivalTime: "10:25:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 165,
            },
            {
              origin: "TPE",
              destination: "KIX",
              carrierCode: "IT",
              flightNumber: "212",
              departureTime: "14:15:00",
              arrivalTime: "18:00:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 165,
            },
            {
              origin: "TPE",
              destination: "KIX",
              carrierCode: "IT",
              flightNumber: "212",
              departureTime: "15:15:00",
              arrivalTime: "19:00:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 165,
            },
            {
              origin: "KIX",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "211",
              departureTime: "11:15:00",
              arrivalTime: "13:10:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: true,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 175,
            },
            {
              origin: "KIX",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "211",
              departureTime: "11:45:00",
              arrivalTime: "13:45:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 180,
            },
            {
              origin: "KIX",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "213",
              departureTime: "19:50:00",
              arrivalTime: "21:45:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 175,
            },
            {
              origin: "KIX",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "213",
              departureTime: "20:00:00",
              arrivalTime: "21:50:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 170,
            },
            {
              origin: "KHH",
              destination: "KIX",
              carrierCode: "IT",
              flightNumber: "284",
              departureTime: "07:00:00",
              arrivalTime: "10:55:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: false,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 175,
            },
            {
              origin: "KIX",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "285",
              departureTime: "11:15:00",
              arrivalTime: "13:40:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 205,
            },
            {
              origin: "KIX",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "285",
              departureTime: "11:55:00",
              arrivalTime: "14:00:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 185,
            },
            {
              origin: "KIX",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "285",
              departureTime: "12:00:00",
              arrivalTime: "14:00:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 180,
            },
          ],
        },
        {
          iataCode: "CTS",
          schedules: [
            {
              origin: "TPE",
              destination: "CTS",
              carrierCode: "IT",
              flightNumber: "234",
              departureTime: "06:20:00",
              arrivalTime: "11:05:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 225,
            },
            {
              origin: "CTS",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "235",
              departureTime: "12:05:00",
              arrivalTime: "15:20:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 255,
            },
            {
              origin: "KHH",
              destination: "CTS",
              carrierCode: "IT",
              flightNumber: "260",
              departureTime: "06:55:00",
              arrivalTime: "12:05:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 250,
            },
            {
              origin: "KHH",
              destination: "CTS",
              carrierCode: "IT",
              flightNumber: "260",
              departureTime: "08:00:00",
              arrivalTime: "13:05:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 245,
            },
            {
              origin: "CTS",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "261",
              departureTime: "12:55:00",
              arrivalTime: "16:30:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 275,
            },
            {
              origin: "CTS",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "261",
              departureTime: "13:55:00",
              arrivalTime: "17:15:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 260,
            },
          ],
        },
        {
          iataCode: "OKA",
          schedules: [
            {
              origin: "TPE",
              destination: "OKA",
              carrierCode: "IT",
              flightNumber: "230",
              departureTime: "06:50:00",
              arrivalTime: "09:20:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 90,
            },
            {
              origin: "TPE",
              destination: "OKA",
              carrierCode: "IT",
              flightNumber: "232",
              departureTime: "18:30:00",
              arrivalTime: "20:50:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 80,
            },
            {
              origin: "OKA",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "231",
              departureTime: "10:10:00",
              arrivalTime: "10:40:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 90,
            },
            {
              origin: "OKA",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "233",
              departureTime: "21:40:00",
              arrivalTime: "22:10:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: false,
                friday: true,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 90,
            },
            {
              origin: "KHH",
              destination: "OKA",
              carrierCode: "IT",
              flightNumber: "288",
              departureTime: "10:10:00",
              arrivalTime: "13:00:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 110,
            },
            {
              origin: "OKA",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "289",
              departureTime: "14:00:00",
              arrivalTime: "14:55:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: false,
                friday: true,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 115,
            },
          ],
        },
        {
          iataCode: "HKD",
          schedules: [
            {
              origin: "TPE",
              destination: "HKD",
              carrierCode: "IT",
              flightNumber: "236",
              departureTime: "07:00:00",
              arrivalTime: "11:30:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 210,
            },
            {
              origin: "HKD",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "237",
              departureTime: "12:30:00",
              arrivalTime: "15:45:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 255,
            },
          ],
        },
        {
          iataCode: "FUK",
          schedules: [
            {
              origin: "TPE",
              destination: "FUK",
              carrierCode: "IT",
              flightNumber: "240",
              departureTime: "06:15:00",
              arrivalTime: "09:35:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 140,
            },
            {
              origin: "TPE",
              destination: "FUK",
              carrierCode: "IT",
              flightNumber: "240",
              departureTime: "06:45:00",
              arrivalTime: "10:05:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: true,
                thursday: false,
                friday: true,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 140,
            },
            {
              origin: "FUK",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "241",
              departureTime: "10:25:00",
              arrivalTime: "11:55:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 150,
            },
            {
              origin: "FUK",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "241",
              departureTime: "10:55:00",
              arrivalTime: "12:25:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: true,
                thursday: false,
                friday: true,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 150,
            },
          ],
        },
        {
          iataCode: "NGO",
          schedules: [
            {
              origin: "TPE",
              destination: "NGO",
              carrierCode: "IT",
              flightNumber: "206",
              departureTime: "09:00:00",
              arrivalTime: "12:55:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 175,
            },
            {
              origin: "NGO",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "207",
              departureTime: "13:45:00",
              arrivalTime: "15:50:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 185,
            },
            {
              origin: "KHH",
              destination: "NGO",
              carrierCode: "IT",
              flightNumber: "268",
              departureTime: "15:00:00",
              arrivalTime: "19:15:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 195,
            },
            {
              origin: "NGO",
              destination: "KHH",
              carrierCode: "IT",
              flightNumber: "269",
              departureTime: "20:05:00",
              arrivalTime: "22:30:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 205,
            },
          ],
        },
        {
          iataCode: "OKJ",
          schedules: [
            {
              origin: "TPE",
              destination: "OKJ",
              carrierCode: "IT",
              flightNumber: "214",
              departureTime: "11:30:00",
              arrivalTime: "15:05:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 155,
            },
            {
              origin: "OKJ",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "215",
              departureTime: "15:55:00",
              arrivalTime: "17:40:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 165,
            },
          ],
        },
        {
          iataCode: "KMQ",
          schedules: [
            {
              origin: "TPE",
              destination: "KMQ",
              carrierCode: "IT",
              flightNumber: "252",
              departureTime: "12:10:00",
              arrivalTime: "16:05:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 175,
            },
            {
              origin: "KMQ",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "253",
              departureTime: "16:55:00",
              arrivalTime: "19:10:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 195,
            },
          ],
        },
        {
          iataCode: "HNA",
          schedules: [
            {
              origin: "TPE",
              destination: "HNA",
              carrierCode: "IT",
              flightNumber: "258",
              departureTime: "12:25:00",
              arrivalTime: "17:00:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 215,
            },
            {
              origin: "HNA",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "259",
              departureTime: "18:00:00",
              arrivalTime: "21:00:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: true,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 240,
            },
          ],
        },
        {
          iataCode: "SDJ",
          schedules: [
            {
              origin: "TPE",
              destination: "SDJ",
              carrierCode: "IT",
              flightNumber: "254",
              departureTime: "13:45:00",
              arrivalTime: "18:10:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 205,
            },
            {
              origin: "SDJ",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "255",
              departureTime: "19:00:00",
              arrivalTime: "21:55:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 235,
            },
          ],
        },
        {
          iataCode: "KIJ",
          schedules: [
            {
              origin: "TPE",
              destination: "KIJ",
              carrierCode: "IT",
              flightNumber: "228",
              departureTime: "13:45:00",
              arrivalTime: "18:00:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 195,
            },
            {
              origin: "KIJ",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "229",
              departureTime: "18:50:00",
              arrivalTime: "21:25:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 215,
            },
          ],
        },
      ],
    },
    {
      countryCode: "KR",
      stationSchedules: [
        {
          iataCode: "ICN",
          schedules: [
            {
              origin: "TPE",
              destination: "ICN",
              carrierCode: "IT",
              flightNumber: "602",
              departureTime: "20:00:00",
              arrivalTime: "23:30:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 150,
            },
            {
              origin: "ICN",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "603",
              departureTime: "00:30:00",
              arrivalTime: "02:15:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 165,
            },
          ],
        },
        {
          iataCode: "CJU",
          schedules: [
            {
              origin: "TPE",
              destination: "CJU",
              carrierCode: "IT",
              flightNumber: "654",
              departureTime: "06:40:00",
              arrivalTime: "09:25:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 105,
            },
            {
              origin: "TPE",
              destination: "CJU",
              carrierCode: "IT",
              flightNumber: "654",
              departureTime: "06:40:00",
              arrivalTime: "09:35:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: true,
                thursday: false,
                friday: true,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 115,
            },
            {
              origin: "TPE",
              destination: "CJU",
              carrierCode: "IT",
              flightNumber: "654",
              departureTime: "06:40:00",
              arrivalTime: "09:45:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 125,
            },
            {
              origin: "CJU",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "655",
              departureTime: "10:20:00",
              arrivalTime: "11:35:00",
              daysOfWeek: {
                monday: true,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 135,
            },
            {
              origin: "CJU",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "655",
              departureTime: "10:30:00",
              arrivalTime: "11:35:00",
              daysOfWeek: {
                monday: false,
                tuesday: true,
                wednesday: true,
                thursday: false,
                friday: true,
                saturday: true,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 125,
            },
            {
              origin: "CJU",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "655",
              departureTime: "10:40:00",
              arrivalTime: "11:45:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: true,
                friday: false,
                saturday: false,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 125,
            },
          ],
        },
        {
          iataCode: "PUS",
          schedules: [
            {
              origin: "TPE",
              destination: "PUS",
              carrierCode: "IT",
              flightNumber: "606",
              departureTime: "16:40:00",
              arrivalTime: "19:55:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 135,
            },
            {
              origin: "PUS",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "607",
              departureTime: "20:45:00",
              arrivalTime: "22:10:00",
              daysOfWeek: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: true,
                sunday: true,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 145,
            },
            {
              origin: "PUS",
              destination: "TPE",
              carrierCode: "IT",
              flightNumber: "607",
              departureTime: "21:05:00",
              arrivalTime: "22:25:00",
              daysOfWeek: {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: false,
                sunday: false,
              },
              operationDateSummary: "2026/03/29-2026/10/24",
              overnight: 0,
              durationInMinutes: 140,
            },
          ],
        },
      ],
    },
  ],
}

export default flightData
